/**
 * Caches the Clinic Owner's last known /onboarding/status response so the
 * onboarding page can resume on the right step immediately on reload, before
 * the fresh status refetch (server is always the source of truth) lands.
 */

const STORAGE_KEY = 'clinic-onboarding-progress';
const VERSION = 1;

function tryParseJson(raw) {
  if (raw === null || raw === undefined || raw === '') {
    return null;
  }
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

/** @returns {{ version: number, flow: string, steps: Array, nextStep: string|null } | null} */
export function getClinicOnboardingProgress() {
  const parsed = tryParseJson(localStorage.getItem(STORAGE_KEY));
  if (parsed && parsed.version === VERSION && Array.isArray(parsed.steps)) {
    return parsed;
  }
  return null;
}

export function saveClinicOnboardingProgress({ flow, steps, nextStep }) {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        version: VERSION,
        flow: flow ?? null,
        steps: steps ?? [],
        nextStep: nextStep ?? null,
      })
    );
  } catch {
    // ignore quota / private mode
  }
}

export function clearClinicOnboardingProgress() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
